import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { Controller } from 'react-hook-form';

const SELECT_FIELD_STYLE = {
  width: '100%',
};

/**
 * @param {any} props
 */
const DefaultSelectField = ({
  control,
  name: propName,
  id,
  label,
  placeholder,
  inputs,
  inputElements,
  width = '250px',
  style = {},
  value,
  onChange,
  disabled,
  className = '',
  multiple = false,
  error,
  onClose,
}) => {
  // RHF mode: when control + name are provided, wrap in Controller
  if (control && propName) {
    return (
      <Controller
        name={propName}
        control={control}
        render={({ field, fieldState }) => (
          <DefaultSelectField
            name={field.name}
            value={field.value ?? ''}
            onChange={(event) => field.onChange(event.target.value)}
            label={label}
            inputs={inputs}
            inputElements={inputElements}
            error={fieldState.error?.message}
            id={id}
            placeholder={placeholder}
            width={width}
            style={style}
            disabled={disabled}
            className={className}
            multiple={multiple}
            onClose={onClose}
          />
        )}
      />
    );
  }

  const name = propName;
  if (placeholder) {
    style = { ...style, '--data-placeholder': `"${placeholder}"` };
  }

  if (error) {
    className += ' has-error';
  }

  const selectId = id || 'select-' + (label || placeholder || '').replace(/ /g, '_');
  // Without labelId the MUI Select's accessible name is just its displayed
  // value, so a screen reader announces a bare option with no field context.
  // Undefined when there is no label, leaving unlabelled call sites as they were.
  const labelId = label ? `${selectId}-label` : undefined;

  return (
    <FormControl
      className={`default-select-field ${className}`}
      style={{ ...SELECT_FIELD_STYLE, width, ...style }}
    >
      <InputLabel id={labelId} htmlFor={selectId}>
        {label}
      </InputLabel>
      <Select
        id={selectId}
        labelId={labelId}
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        multiple={multiple}
        value={value}
        onChange={onChange}
        defaultValue={value}
        onClose={onClose}
      >
        {inputElements ||
          inputs.map((type) => (
            <MenuItem id={`menu-item-${type}`} className={type} value={type} key={type}>
              {type}
            </MenuItem>
          ))}
      </Select>
      <div className="error-message">{error}</div>
    </FormControl>
  );
};

export default DefaultSelectField;
